<template>

	<v-row class="mt-4 pl-0 ml-n6 mb-n3">
		<v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="px-3 pt-0 pb-0">
			<v-checkbox
				cols="12" xs="12" sm="12" md="3"
				class="mx-3 pt-2 mt-0"
				label="Check this if you want default value to be checked"
				v-model="field.typeProperties.defaultValue"
			></v-checkbox>
		</v-col>
	</v-row>

</template>


<script>

// ----------------------------------------------------
//
//  Main script
//
// ----------------------------------------------------

import agile from "@/shift/agile";
import fb from '@/shift/fb';


export default
{
	name: 'ViewBooleanField',

	props:
	{
		id: { type: String },
		field: { type: Object },
	},

	data: () =>
	({
		
		
	}),



	computed:
	{
		agile()
		{
			return agile;
		},
		
		routeKey()
		{
			return this.$route.params.key;
		},
	},



	created()
	{
		fb;

	},

	mounted()
	{
		
	},

	methods:
	{
		
	}

}

</script>

